"use client";

import { useEffect, useState } from "react";

export type DialKitEmbeddedTheme = "light" | "dark" | "system";

/**
 * Prefer-over host theme for embedded DialKit atoms (outside DialRoot dock).
 * Vendor CSS tokens only resolve under `.dialkit-root` (+ optional data-theme).
 * Syncs to the app `html.dark` / `html.light` class from next-themes.
 */
export function useDialKitEmbeddedTheme(): DialKitEmbeddedTheme {
	const [theme, setTheme] = useState<DialKitEmbeddedTheme>("system");

	useEffect(() => {
		const root = document.documentElement;
		function sync() {
			if (root.classList.contains("dark")) {
				setTheme("dark");
				return;
			}
			if (root.classList.contains("light")) {
				setTheme("light");
				return;
			}
			setTheme("system");
		}
		sync();
		const observer = new MutationObserver(sync);
		observer.observe(root, {
			attributes: true,
			attributeFilter: ["class"],
		});
		return () => observer.disconnect();
	}, []);

	return theme;
}

/** Class DialKit styles.css scopes theme tokens to — required for embedded mounts. */
export const DIALKIT_EMBEDDED_HOST_CLASS = "dialkit-root" as const;
